// src/components/dialog/DlgProfilePicture.tsx

import { DeleteTwoTone, PublishTwoTone } from '@mui/icons-material'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'

import { KARMA_BasicDialog } from '@/types/karma/dialog'

import avatar from '../../assets/img/default-avatar.png'
import { OperatorData, useOperator, useOperatorApi } from '../../hooks'

export const DlgProfilePicture = ({ onClose, open }: KARMA_BasicDialog) => {
  const operatorApi = useOperatorApi()
  const getFileUpload = operatorApi.getFileUpload

  const opData: OperatorData = useOperator()

  const [userData, setUserData] = useState<{ image_url?: string | File }>({})

  const [imagePreviewUrl, setImagePreviewUrl] = useState(avatar)

  const CLEAR_DISABLED = !userData.image_url && userData.image_url === ''

  const ref = useRef<HTMLInputElement | null>(null)

  const onClear = () => {
    setImagePreviewUrl(avatar)
    setUserData(prev => ({ ...prev, image_url: avatar }))
    if (ref.current) ref.current.value = ''
  }

  const onClick = () => ref.current?.click()

  const onUpload = event => {
    const image_file = event.target.files[0]
    if (!image_file) return

    event.preventDefault()

    // sofortige Vorschau
    const reader = new FileReader()
    reader.readAsDataURL(image_file)
    reader.onloadend = () => setImagePreviewUrl(reader.result as string)

    // lokale User-Daten aktualisieren (für späteres Speichern)
    setUserData(prev => ({ ...prev, image_url: image_file }))

    // direkt zu S3 hochladen (ersetzt Redux fileUpload)
    getFileUpload(image_file, 'users')
  }

  useEffect(() => {
    if (!opData) return

    const { image_url } = opData

    setUserData({ image_url })
    setImagePreviewUrl(image_url || avatar)
  }, [opData])

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Profilbild von {opData?.first_name} {opData?.last_name}
      </DialogTitle>

      <DialogContent>
        <Box alt={''} component={'img'} src={imagePreviewUrl} />
      </DialogContent>

      <DialogActions>
        <Tooltip title={'Hochladen'}>
          <Button onClick={onClick}>
            <PublishTwoTone sx={{ mr: 1 }} /> Upload
          </Button>
        </Tooltip>

        <input
          accept={'image/*'}
          hidden
          onChange={onUpload}
          ref={ref}
          type={'file'}
        />

        <Tooltip title={'Löschen'}>
          <Button disabled={CLEAR_DISABLED} onClick={onClear}>
            <DeleteTwoTone sx={{ mr: 1 }} /> Löschen
          </Button>
        </Tooltip>
      </DialogActions>
    </Dialog>
  )
}
